module.exports = __webpack_public_path__ + "static/media/place_holder_user.9b89ba3c.png";